// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConstraintAndAllowanceCatalogPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ConstraintAndAllowanceCatalogPageQuery = { __typename?: 'Query', globalPlanConstraintItems: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string, name: string, numberOfTimesUsed: number, lagInDays: number, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> };

export type ConstraintAndAllowanceCatalogPage_GlobalPlanConstraintItemFragment = { __typename?: 'GlobalPlanConstraintItem', id: string, name: string, numberOfTimesUsed: number, lagInDays: number, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type DeleteGlobalPlanConstraintItemMutationVariables = Types.Exact<{
  input: Types.DeleteGlobalPlanConstraintItemInput;
}>;


export type DeleteGlobalPlanConstraintItemMutation = { __typename?: 'Mutation', deleteGlobalPlanConstraintItem: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export const ConstraintAndAllowanceCatalogPage_GlobalPlanConstraintItemFragmentDoc = gql`
    fragment ConstraintAndAllowanceCatalogPage_GlobalPlanConstraintItem on GlobalPlanConstraintItem {
  id
  name
  numberOfTimesUsed
  lagInDays
  canDelete {
    allowed
    disabledReasons {
      message
    }
  }
}
    `;
export const ConstraintAndAllowanceCatalogPageDocument = gql`
    query ConstraintAndAllowanceCatalogPage {
  globalPlanConstraintItems {
    ...ConstraintAndAllowanceCatalogPage_GlobalPlanConstraintItem
  }
}
    ${ConstraintAndAllowanceCatalogPage_GlobalPlanConstraintItemFragmentDoc}`;

/**
 * __useConstraintAndAllowanceCatalogPageQuery__
 *
 * To run a query within a React component, call `useConstraintAndAllowanceCatalogPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstraintAndAllowanceCatalogPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstraintAndAllowanceCatalogPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useConstraintAndAllowanceCatalogPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>(ConstraintAndAllowanceCatalogPageDocument, options);
      }
export function useConstraintAndAllowanceCatalogPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>(ConstraintAndAllowanceCatalogPageDocument, options);
        }
// @ts-ignore
export function useConstraintAndAllowanceCatalogPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>;
export function useConstraintAndAllowanceCatalogPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConstraintAndAllowanceCatalogPageQuery | undefined, ConstraintAndAllowanceCatalogPageQueryVariables>;
export function useConstraintAndAllowanceCatalogPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>(ConstraintAndAllowanceCatalogPageDocument, options);
        }
export type ConstraintAndAllowanceCatalogPageQueryHookResult = ReturnType<typeof useConstraintAndAllowanceCatalogPageQuery>;
export type ConstraintAndAllowanceCatalogPageLazyQueryHookResult = ReturnType<typeof useConstraintAndAllowanceCatalogPageLazyQuery>;
export type ConstraintAndAllowanceCatalogPageSuspenseQueryHookResult = ReturnType<typeof useConstraintAndAllowanceCatalogPageSuspenseQuery>;
export type ConstraintAndAllowanceCatalogPageQueryResult = ApolloReactCommon.QueryResult<ConstraintAndAllowanceCatalogPageQuery, ConstraintAndAllowanceCatalogPageQueryVariables>;
export const DeleteGlobalPlanConstraintItemDocument = gql`
    mutation DeleteGlobalPlanConstraintItem($input: DeleteGlobalPlanConstraintItemInput!) {
  deleteGlobalPlanConstraintItem(input: $input) {
    emptyResult
  }
}
    `;

/**
 * __useDeleteGlobalPlanConstraintItemMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalPlanConstraintItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalPlanConstraintItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalPlanConstraintItemMutation, { data, loading, error }] = useDeleteGlobalPlanConstraintItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGlobalPlanConstraintItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteGlobalPlanConstraintItemMutation, DeleteGlobalPlanConstraintItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteGlobalPlanConstraintItemMutation, DeleteGlobalPlanConstraintItemMutationVariables>(DeleteGlobalPlanConstraintItemDocument, options);
      }
export type DeleteGlobalPlanConstraintItemMutationHookResult = ReturnType<typeof useDeleteGlobalPlanConstraintItemMutation>;
export type DeleteGlobalPlanConstraintItemMutationResult = ApolloReactCommon.MutationResult<DeleteGlobalPlanConstraintItemMutation>;